import {
  SAVE_NEWS_FAILURE,
  SAVE_NEWS_SUCCESS,
  SAVE_NEWS_REQUEST,
  FETCH_NEWSS_REQUEST,
  FETCH_NEWSS_SUCCESS,
  FETCH_NEWSS_FAILURE,
  DELETE_NEWS_REQUEST,
  DELETE_NEWS_SUCCESS,
  DELETE_NEWS_FAILURE,
  FETCH_NEWS_REQUEST,
  FETCH_NEWS_SUCCESS,
  FETCH_NEWS_FAILURE,
  FETCH_NEWS_COMPLETE_REQUEST,
  FETCH_NEWS_COMPLETE_SUCCESS,
  FETCH_NEWS_COMPLETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  newss: [],
  news: null,
  newsComplete: null,
  newsImageUrl: '',
  loading: false,
  error: null,
  simplepNewsList: null,
  simplepNewsListLoading: false,
  custompNewsList: null,
  custompNewsListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_NEWSS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEWSS_SUCCESS:
      return {
        ...state,
        loading: false,
        newss: action.payload,
      };

    case FETCH_NEWSS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        newss: [],
      };
    case SAVE_NEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_NEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_NEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_NEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_NEWS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload,
      };

    case FETCH_NEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        news: null,
      };
    case FETCH_NEWS_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEWS_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        newsComplete: action.payload,
      };

    case FETCH_NEWS_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        newsComplete: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
